import { useStore } from '../store';
import { BIG_SCREEN_WIDTH, TABLET_SCREEN_WIDTH } from '../constants/general';

export const screenTypeTracker = () => {
  const { setIsBigScreen, setCurrentWidth, setIsMobileScreen } = useStore.getState();

  const updateWindowDimensions = () => {
    const { innerWidth } = window;
    setCurrentWidth(innerWidth);
    setIsBigScreen(innerWidth >= BIG_SCREEN_WIDTH);
    setIsMobileScreen(innerWidth < TABLET_SCREEN_WIDTH);

    return '';
  };

  window.addEventListener('resize', updateWindowDimensions);
  window.addEventListener('load', updateWindowDimensions);
};
